module.exports = __webpack_public_path__ + "img/130.3.fb3e87a7.png";